import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const WriterProtectedRoute = ({ children }) => {
  const { user, loading, isWriter } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user && isWriter()) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default WriterProtectedRoute;
